export const getFontClassByDigits = (
    total: string | number | undefined,
    minSize: number = 4,
    maxSize: number = 9
): string => {
    let result = "";
    if (total) {
        const digits = total.toString().length;

        if (digits <= minSize) {
            result = "";
        }

        if (digits > minSize && digits < maxSize) {
            result = `f${digits.toString()}-digits`;
        }

        if (digits >= maxSize) {
            result = `f${maxSize}-digits`;
        }
    }
    return result;
};

export const toFixedString = (val: number, precision = 2, delimiter = ".") => {
    let res = val.toString(10);
    let delimiterIndex: number = res.indexOf(delimiter);
    res = delimiterIndex === -1 ? res : res.substr(0, delimiterIndex + 1 + precision);
    return res;
};
